import { BASE_URL } from './config';

// API endpoints for the Blueroad application
export const API_ENDPOINTS = {
  // Home screen
  HOME: `${BASE_URL}api/home`,
  
  // Car listings
  FILTERS: `${BASE_URL}api/filters`,
  CAR_LIST: `${BASE_URL}api/cars`,
  POPULAR_CARS: `${BASE_URL}api/popular-cars`,
  
  // Car details
  CAR_DETAIL: (slug) => `${BASE_URL}api/car/${slug}`,
};

// Helper function to build query parameters
export const buildQueryParams = (params) => {
  const queryParams = new URLSearchParams();
  
  Object.keys(params).forEach(key => {
    const value = params[key];
    if (value !== undefined && value !== null && value !== '') {
      if (Array.isArray(value)) {
        value.forEach(item => queryParams.append(`${key}[]`, item));
      } else {
        queryParams.append(key, value);
      }
    }
  });

  return queryParams.toString().replace(/%5B/g, '[').replace(/%5D/g, ']');
};


// Example API call function
export const fetchFromAPI = async (endpoint, params = {}) => {
  const queryString = buildQueryParams(params);
  //console.log("query string =======> ",queryString);
  const url = queryString ? `${endpoint}?${queryString}` : endpoint;
  //console.log("query string =======> ",url);
  
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('API request failed:', error);
    throw error;
  }
};
